import { isObject } from "../../utils/utils";

export const formatLogMessage = (logLevel, msg, error) => {
    const date = new Date().toISOString();
    const dateFormatted = date.substr(11, 12);
    const errorMsg = prepareErrorMessage(error);
    return `${dateFormatted} | ${logLevel} | ${msg}${errorMsg}`;
}

export const prepareErrorMessage = (error) => {
    let errorMessage = ""
    if (!error || error === 'undefined') return errorMessage;

    if (isObject(error)) {
        if (error?.config?.headers && isObject(error.config.headers)) {
            for (const key of Object.keys(error.config.headers)) {
                error.config.headers[key] = 'n/a'
            }
        }

        errorMessage = JSON.stringify(error, Object.getOwnPropertyNames(error));
    } else {
        errorMessage = error;
    }

    return ` | Error: ${errorMessage}`;
}